import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import DisplayReceiptIr from "./pages/DisplayReceiptIr";
import TradePromo from "./pages/TradePromo";
import ConsumerPromo from "./pages/ConsumerPromo";
import PngTnc from "./pages/PngTnc";
import PrivacyPolicy from "./pages/PrivacyPolicy";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="display-receipt-ir" element={<DisplayReceiptIr />} />
        <Route path="trade-promo" element={<TradePromo />} />
        <Route path="consumer-promo" element={<ConsumerPromo />} />
        <Route path="s&k-neurobion" element={<PngTnc />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
